import React, { useState, useEffect } from "react";
import "./App.css";
import axios from "axios";
import ForecastDay from "./ForecastDay";
import celebi from "./media/celebi.gif";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);
  useEffect(() => {
    setLoaded(false);
  }, [props.coordinates]);
  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }
  if (loaded) {
    return (
      <div className="weatherForecast">
        <div>
          <img src={celebi} alt="celebi" className="mb-3" />
        </div>
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
            if (index < 5) {
              return (
                <div className="col" key={index}>
                  <ForecastDay data={dailyForecast} />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  } else {
    let latitude = props.coordinates.latitude;
    let longitude = props.coordinates.longitude;
    let url = `https://api.shecodes.io/weather/v1/forecast?lon=${longitude}&lat=${latitude}&key=b01ffcc8e0f35c8a34d9t4ee3f03o916`;
    axios.get(url).then(handleResponse);
  }
}
